import cn from 'classnames'
import { memo, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as BusinessPerson } from 'clickNgo/assets/icons/business-person.svg'
import { ReactComponent as HotOffer } from 'clickNgo/assets/icons/hot-offer.svg'
import { ReactComponent as PriceTag } from 'clickNgo/assets/icons/price-tag.svg'
import { Translation } from 'cng-common/features/translations'
import { Tooltip } from 'core-components/library/tooltip'

import { promotionProductTranslationKey } from '../../configs/translation'
import { OfferTypeMarker } from '../../models'

import styles from './OfferMarker.module.scss'

interface Props {
  type: OfferTypeMarker
  className?: string
}

const MARKER_CONFIG: Record<OfferTypeMarker, { icon: ReactNode; modifier: string }> = {
  deal: { icon: <PriceTag viewBox="0 0 24 24" />, modifier: styles.deal },
  hot_offer: { icon: <HotOffer viewBox="0 0 24 24" />, modifier: styles.hotOffer },
  end_customer: { icon: <BusinessPerson viewBox="0 0 24 24" />, modifier: styles.endCustomer },
}

export const OfferMarker = memo<Props>(({ type, className }) => {
  const { t } = useTranslation()
  const { icon, modifier } = MARKER_CONFIG[type]

  const labelTranslationKey = `${promotionProductTranslationKey}-marker-${type}`

  return (
    <Tooltip tipContent={() => <Translation text={labelTranslationKey} span />}>
      <span
        className={cn(styles.root, modifier, className)}
        role="img"
        aria-label={t(labelTranslationKey)}
      >
        {icon}
      </span>
    </Tooltip>
  )
})

OfferMarker.displayName = 'OfferMarker'
